// sessionService.js - Manejo de sesiones anónimas con cookies
import { v4 as uuidv4 } from 'uuid'

export const sessionService = {
  SESSION_COOKIE_NAME: 'ldda-session-id',
  SESSION_EXPIRY_DAYS: 30,

  // Generar nuevo ID de sesión (UUID)
  generateSessionId() {
    return uuidv4()
  },

  // Obtener ID de sesión desde cookie o crear uno nuevo
  getSessionId() {
    try {
      console.log('🍪 [SessionService] Cookies disponibles:', document.cookie)
      
      let sessionId = this.getCookie(this.SESSION_COOKIE_NAME)
      console.log('🔍 [SessionService] sessionId obtenido de cookie:', sessionId)
      
      if (!sessionId) {
        sessionId = this.generateSessionId()
        this.setSessionId(sessionId)
        console.log('🆔 [SessionService] Nueva sesión creada:', sessionId)
      } else {
        console.log('🆔 [SessionService] Sesión existente encontrada:', sessionId)
      }
      
      return sessionId
    } catch (error) {
      console.error('❌ [SessionService] Error obteniendo session ID:', error)
      // Fallback: generar nuevo ID sin guardarlo en cookie
      const fallbackId = this.generateSessionId()
      console.log('🔄 [SessionService] Usando fallback ID:', fallbackId)
      return fallbackId
    }
  },

  // Establecer ID de sesión en cookie
  setSessionId(sessionId) {
    try {
      const expiryDate = new Date()
      expiryDate.setDate(expiryDate.getDate() + this.SESSION_EXPIRY_DAYS)
      
      // En desarrollo (HTTP) no usar 'secure', en producción (HTTPS) sí usarlo
      const isProduction = window.location.protocol === 'https:'
      const secureFlag = isProduction ? 'secure; ' : ''
      const sameSiteFlag = isProduction ? 'samesite=strict' : 'samesite=lax'
      
      document.cookie = `${this.SESSION_COOKIE_NAME}=${sessionId}; expires=${expiryDate.toUTCString()}; path=/; ${secureFlag}${sameSiteFlag}`
      
      console.log('✅ [SessionService] Session ID guardado en cookie:', sessionId)
      console.log('🔧 [SessionService] Modo:', isProduction ? 'Producción (HTTPS)' : 'Desarrollo (HTTP)')
    } catch (error) {
      console.error('❌ [SessionService] Error guardando session ID:', error)
    }
  },

  // Leer cookie específica
  getCookie(name) {
    try {
      const value = `; ${document.cookie}`
      const parts = value.split(`; ${name}=`)
      if (parts.length === 2) {
        return parts.pop().split(';').shift()
      }
      return null
    } catch (error) {
      console.error('❌ [SessionService] Error leyendo cookie:', error)
      return null
    }
  },

  // Eliminar cookie de sesión
  clearSession() {
    try {
      document.cookie = `${this.SESSION_COOKIE_NAME}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`
      console.log('🗑️ [SessionService] Sesión eliminada')
    } catch (error) {
      console.error('❌ [SessionService] Error eliminando sesión:', error)
    }
  },

  // Método de debug para verificar el estado de cookies
  debugCookies() {
    console.log('🍪 [DEBUG] Todas las cookies:', document.cookie)
    const sessionId = this.getCookie(this.SESSION_COOKIE_NAME)
    console.log('🆔 [DEBUG] sessionId actual:', sessionId)
    console.log('🌐 [DEBUG] Protocolo:', window.location.protocol)
    console.log('🏠 [DEBUG] Host:', window.location.host)
    
    // Intentar leer la cookie directamente
    const cookies = document.cookie.split(';')
    const sessionCookie = cookies.find(cookie => cookie.trim().startsWith(this.SESSION_COOKIE_NAME))
    console.log('🔍 [DEBUG] Cookie encontrada:', sessionCookie)
    
    return {
      allCookies: document.cookie,
      sessionId,
      protocol: window.location.protocol,
      host: window.location.host,
      sessionCookie
    }
  }
}

export default sessionService
